// @flow

import * as React from 'react';

import { Base, Placeholder, FqdnPlaceholder } from '@gandi/ui';

export function DomainPlaceholder(): React.MixedElement {
  return (
    <>
      <Base flex flexGrow1 flexJustifyBetween>
        <FqdnPlaceholder />
      </Base>
      <Base flex flexJustifyEnd flexAlignItemsCenter gap="xsmall">
        <Placeholder chars={10} />
      </Base>
    </>
  );
}
